import { useMutation } from "react-query";

import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

interface EditTreatmentPayloadP {
  projectId: string;
  featureId: string;
  treatmentId: string;
  name?: string;
  rolloutPercentage?: number;
  configuration?: Record<string, string>;
  description?: string | null;
  default?: boolean;
}

const editTreatment = async (payload: EditTreatmentPayloadP) => {
  try {
    const url = paths.editTreatment();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useEditTreatment = () => {
  return useMutation(editTreatment);
};
